import React from 'react';
import { Box, Tab, Tabs, SxProps, Theme } from '@mui/material';
import { TabPanel } from './TabPanel';
import { useTabState } from '../../hooks/useTabState';

export interface TabConfig {
	label: string;
	content: React.ReactNode;
}

export interface PersistentTabsProps {
	pageKey: string;
	tabs: TabConfig[];
	sx?: SxProps<Theme>;
	tabsSx?: SxProps<Theme>;
	contentSx?: SxProps<Theme>;
	ttlMinutes?: number;
}

export const PersistentTabs: React.FC<PersistentTabsProps> = ({
	pageKey,
	tabs,
	sx,
	tabsSx,
	contentSx,
	ttlMinutes = 30,
}) => {
	const { tabValue, handleTabChange } = useTabState({
		key: pageKey,
		ttlMinutes
	});

	return (
		<Box sx={{
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			overflow: 'hidden',
			...sx
		}}>
			<Tabs
				value={tabValue}
				onChange={handleTabChange}
				variant="scrollable"
				scrollButtons="auto"
				sx={{
					borderBottom: 1,
					borderColor: 'divider',
					mb: 2,
					flexShrink: 0,
					...tabsSx
				}}
			>
				{tabs.map((tab, index) => (
					<Tab key={index} label={tab.label} />
				))}
			</Tabs>

			<Box sx={{
				flex: 1,
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
				minHeight: 0,
				...contentSx
			}}>
				{tabs.map((tab, index) => (
					<TabPanel key={index} value={tabValue} index={index}>
						{tab.content}
					</TabPanel>
				))}
			</Box>
		</Box>
	);
};